module.exports = __webpack_public_path__ + "img/MDI-microsoft-excel.f72f8166.svg";